import {
  isUserActionNeedPhotoVerification,
  isUserNeedKyc,
  isUserNeedPartialVerification,
  needsOnlyBankAccounts,
  needsVerification,
  PhotoVerificationAction,
} from '@atlas/core';

const isActionNeedVerification = (account, operation) =>
  isUserActionNeedPhotoVerification(
    account,
    operation === 'withdrawal'
      ? PhotoVerificationAction.WITHDRAWAL
      : PhotoVerificationAction.DEPOSIT,
  );

export const isPaymentAllowed = (account, bankAccounts, operation, autofillProhibited) => {
  return (
    !needsVerification(account, bankAccounts) ||
    (needsVerification(account, bankAccounts) && !isActionNeedVerification(account, operation)) ||
    (needsOnlyBankAccounts(account, bankAccounts) && autofillProhibited)
  );
};

export const isPartialVerification = (account, operation) =>
  isUserNeedPartialVerification(account) &&
  isUserNeedKyc(account) &&
  isActionNeedVerification(account, operation);
